var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-v2"},[_c('div',{staticStyle:{"display":"flex"}},[_c('Sidebar'),_c('Main')],1),_c('div',{staticClass:"request-container"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }